import React, {FunctionComponent} from "react";
const styles = require("./jumbo.component.scss");

interface JumboProps {
    title: string;
    subTitle: string;
    topImage: string;
    bottomBorder?: boolean;
}


export const Jumbo: FunctionComponent<JumboProps> = props => {
    const {title, subTitle, topImage, bottomBorder} = props;

    return (
        <div className={`${styles.topSection} ${bottomBorder ? styles.bottomBorder : ''}`}>
            <div className={styles.topInside}>
                <div className={styles.topText}>
                    <div className={styles.textChunk}>
                        <h1>
                            {title}
                        </h1>
                        <h2 className={styles.subTitle}>
                            {subTitle}
                        </h2>
                    </div>
                </div>
                <div className={styles.topImage + ' ' + styles.smallerTopImage}>
                    <img src={topImage} alt={''}/>
                </div>
            </div>
        </div>
    );
};
